var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarUnchecked(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.25C7.41421 2.25 7.75 2.58579 7.75 3V3.99995H12.25V3C12.25 2.58579 12.5858 2.25 13 2.25C13.4142 2.25 13.75 2.58579 13.75 3V3.99995H14.8571C16.5929 3.99995 18 5.33052 18 6.97185V15.0281C18 16.6694 16.5929 18 14.8571 18H5.14286C3.40711 18 2 16.6694 2 15.0281V6.97185C2 5.33052 3.4071 3.99995 5.14286 3.99995H6.25V3C6.25 2.58579 6.58579 2.25 7 2.25ZM12.25 5.62099V7C12.25 7.41421 12.5858 7.75 13 7.75C13.4142 7.75 13.75 7.41421 13.75 7V5.62099H14.8571C15.6461 5.62099 16.2857 6.22579 16.2857 6.97185V15.0281C16.2857 15.7741 15.6461 16.3789 14.8571 16.3789H5.14286C4.35388 16.3789 3.71429 15.7741 3.71429 15.0281V6.97185C3.71429 6.22579 4.35388 5.62099 5.14286 5.62099H6.25V7C6.25 7.41421 6.58579 7.75 7 7.75C7.41421 7.75 7.75 7.41421 7.75 7V5.62099H12.25Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarUnchecked);
export default __webpack_public_path__ + "static/media/calendar-unchecked.119e7f18.svg";
export { ForwardRef as ReactComponent };